export const DependencyType = {
  ApolloClient: Symbol.for("ApolloClient"),
  ExampleService: Symbol.for("ExampleService"),
  StorageService: Symbol.for("StorageService"),
  AuthenticationService: Symbol.for("AuthenticationService"),
  UserService: Symbol.for("UserService"),
  BatchService: Symbol.for("BatchService"),
  SerialRangeService: Symbol.for("SerialRangeService"),
  ProductTypeService: Symbol.for("ProductTypeService"),
  SoilTypeService: Symbol.for("SoilTypeService"),
  CropTypeService: Symbol.for("CropTypeService"),
  CoverCropService: Symbol.for("CoverCropService"),
  CropService: Symbol.for("CropService"),
  CultivationService: Symbol.for("CultivationService"),
  SoilSampleService: Symbol.for("SoilSampleService"),
  LaboratoryService: Symbol.for("LaboratoryService"),
  LabResultService: Symbol.for("LabResultService"),
  LabIndicatorDefinitionService: Symbol.for("LabIndicatorDefinitionService"),
};
